export const disabledAction	= ():void =>
	// eslint-disable-next-line no-console
	console.warn("action not allowed");
